export const pt2px = (pt, fix = 1) => {
  return ((pt * 4) / 3).toFixed(fix);
};

export const px2pt = (px, fix = 1) => {
  return Math.ceil(((px * 3) / 4).toFixed(fix));
};

// const canvas = document.createElement('canvas');
// const ctx = canvas.getContext('2d');
// const bodyFontFamily = getComputedStyle(document.body).getPropertyValue('font-family');

// export const getTextSize = (text, fontSize = 32, fontWeight = 500, fontFamily = bodyFontFamily) => {
//   const originalFont = ctx.font;
//   ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
//   const metrics = ctx.measureText(text);
//   const actual = Math.abs(metrics.actualBoundingBoxLeft) + Math.abs(metrics.actualBoundingBoxRight);
//   const size = {
//     width: Math.ceil(Math.max(metrics.width, actual)),
//     height: Math.ceil(metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent),
//   };
//   ctx.font = originalFont;
//   return size;
// };

export const fontsList = {
  macos: [
    'Arial',
    'Baoli SC',
    'Hannotate SC',
    'HanziPen SC',
    'Heiti SC',
    'Kaiti SC',
    'Lantinghei SC',
    'Libian SC',
    'LingWai SC',
    'LiSong Pro',
    'Nanum Pen Script',
    'Party LET',
    'PingFang SC',
    'SimSong',
    'Sinhala Sangam MN',
    'Snell Roundhand',
    'Songti SC',
    'STFangsong',
    'STSong',
    'Sukhumvit Set',
    'Thonburi',
    'Toppan Bunkyu',
    'Tsukushi A Round Gothic',
    'Verdana',
    'Xingkai SC',
    'Yuanti SC',
    'YuGothic',
    'YuMincho',
    'Yuppy SC',
  ],
  windows: [
    'Arial',
    'DengXian',
    'FangSong',
    'FZShuTi',
    'FZYaoTi',
    'HP Simolified Hans',
    'HYZhongHei',
    'KaiTi',
    'LiSu',
    'Microsoft JhengHei',
    'Microsoft PhagsPa',
    'Nirmala UI',
    'NSimSun',
    'Rockwell',
    'SimHei',
    'SimSUn',
    'STCaiyun',
    'STFangsong',
    'STHupo',
    'STkaiti',
    'STLiti',
    'STSong',
    'STXihei',
    'STXingkai',
    'STXinwei',
    'STZhongsong',
    'YouYuan',
    'Yu Gothic UI',
  ],
};
